import type { CSSProperties } from 'react';
import { cx } from '@/lib/cx';
import styles from './Sparkle.module.css';

export interface SparkleProps {
  size?: number;
  /** `soft` relleno tenue · `line` solo contorno. */
  variant?: 'soft' | 'line';
  className?: string;
  style?: CSSProperties;
}

/** Destello de 4 puntas: el acento que salpica los 6 mockups. */
export function Sparkle({ size = 18, variant = 'soft', className, style }: SparkleProps) {
  return (
    <svg
      className={cx(styles.sparkle, styles[variant], className)}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      style={style}
    >
      <path d="M12 0.8c.8 6 5.2 10.4 11.2 11.2C17.2 12.8 12.8 17.2 12 23.2c-.8-6-5.2-10.4-11.2-11.2C6.8 11.2 11.2 6.8 12 .8Z" />
    </svg>
  );
}
